import '../node_modules/fullpage.js/dist/jquery.fullpage.min.css'
import './index.scss'

import $ from 'jquery'
// import EmblaCarousel from "embla-carousel";
// import 'fullpage.js/vendors/scrolloverflow'
// import fullpage from 'fullpage.js'
// import fullpage from 'fullpage/build/fullpage'
// import 'jquery.easing'
// import 'fullpage.js/dist/jquery.fullpage.js'
import './vendors/easings.js'
import './vendors/scrolloverflow.js'
import 'fullpage.js'

import home from './page/home/index.js'
import about from './page/about/index.js'
import initiatives from './page/initiatives/index.js'
import projects from './page/projects/index.js'


$(function(){
    // https://github.com/alvarotrigo/fullPage.js/tree/2.9.7
    // $('body').show();
    $("body").animate({opacity:'1'});
    $('body > main').fullpage({
        menu: 'body > header',
		// lockAnchors: false,
		anchors:['home', 'about-us','foundation-initiatives','selected-projects'],
		// navigation: true,
		// navigationPosition: 'bottom',
        // sectionsColor: ['#f2f2f2', '#4BBFC3', '#7BAABE','red'],
        fixedElements: 'body > header',
        // normalScrollElements: 'body > .pop-wrap-bg',
        normalScrollElements: '.section-about .content',
        loopHorizontal:false,
        // autoScrolling:false
        // afterLoad: function(anchorLink, index){
        //     console.log('afterLoad');
        // },
		// afterRender: function(){
        //     console.log('afterRender');
        // },
        // scrollOverflow: true,
        // easing: 'easeInOutCubic',
		// easingcss3: 'ease',
        // onLeave: function(index, nextIndex, direction){
        //     console.log(`afterLoad:${index}`)
        // },
		// afterLoad: function(anchorLink, index){
        //     // $('body > main').fadeIn()
        //     console.log(`afterLoad:${index}`) 
        // },
		// afterRender: function(){
        //     console.log(`afterRender`) },
		// afterResize: function(){
        //     console.log(`afterResize`) },
		// afterResponsive: function(isResponsive){
        //     console.log(`afterResponsive`) 
        // },
		// afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex){
        //     console.log(`afterSlideLoad:${index}`)
        // },
		// onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex){
        //     console.log(`onSlideLeave:${index}`)
        // }
    });
    // $.fn.fullpage.moveTo(1);
});


home.init()
about.init()
initiatives.init()
projects.init()
